import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDataTableContext } from "../../../../../../hooks";
import BaseButton from "../../../../BaseButton/BaseButton";
import { getFontAwesomeIcon } from "../../../../../../utils";

export interface ResetFiltersButtonProps {
	/** The slug used to reset URL parameters */
	slug: string;
	allowedParams?: string[];
}

const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({
	slug,
	allowedParams,
}) => {
	const navigate = useNavigate();
	const { pathname, search } = useLocation();
	const { setSearchCriteria, setToggleStates } = useDataTableContext();

	const params = new URLSearchParams(search);
	const keep = new URLSearchParams();
	for (const [key, val] of params.entries()) {
		if (
			key.endsWith(":group") ||
			key.endsWith("_recordsPerPage") ||
			key.endsWith("_page") ||
			allowedParams?.includes(key)
		) {
			keep.set(key, val);
		}
	}

	const defaultSearch = keep.toString();
	const currentSearch = search.replace(/^\?/, ""); // strip leading "?"

	if (currentSearch === defaultSearch) return null;

	const handleClearFilters = () => {
		setSearchCriteria([]);
		setToggleStates({});
		localStorage.removeItem("activeSortColumns");

		// Rebuild URL with only group + pagination defaults
		const newParams = new URLSearchParams();
		for (const [key, val] of keep.entries()) {
			if (key.endsWith(":group")) newParams.set(key, val);
		}
		["purchase-orders", "inventory_items"].forEach((s) => {
			newParams.set(`${s}_recordsPerPage`, "15");
			newParams.set(`${s}_page`, "1");
		});

		navigate(`${pathname}?${newParams.toString()}`, { replace: true });
		navigate(0);
	};

	return (
		<BaseButton
			text="Reset Filters"
			bgColor="bg-white"
			fontColor="text-crimson-700"
			buttonSize="h-26px"
			shape="rounded-full"
			icon={getFontAwesomeIcon("filterSlash", "regular")}
			iconBreakpoint="max-sm:pr-0"
			additionalClasses="text-crimson-700 rounded-full hover:bg-crimson-300 border-1 border-crimson-700 text-nowrap max-sm:size-8 max-sm:justify-center text-14px px-2"
			as="button"
			textBreakpoint="max-sm:hidden"
			onClick={handleClearFilters}
			fontFamily="font-omnes-medium"
			iconClasses="pr-2"
		/>
	);
};

export default ResetFiltersButton;
